import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { REACT_APP_URL_COUNTRY_LIST_ALL } from '../components/common/Routes/URLs';
import { getListCountryAll } from '../Redux/actions/tempEdgeActions';
import TempEdgeApi from '../services/TempEdgeApi';

let countryListPromise = null;

const useFetchCountryList = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const isMountedRef = useRef(true);

  // Get data from Redux store if it already exists

  const fetchCountryList = useCallback(async () => {
    // Always fetch when called explicitly
    // Don't use cache to ensure fresh data in Dashboard

    // If there's already a request in progress, wait for its result
    if (countryListPromise) {
      try {
        const result = await countryListPromise;
        if (isMountedRef.current) {
          setData(result);
        }
        return result;
      } catch (err) {
        if (isMountedRef.current) {
          setError(err);
          setData([]);
        }
        return [];
      }
    }

    // Create new request
    setLoading(true);
    setError(null);

    countryListPromise = (async () => {
      try {
        const { data: response } = await TempEdgeApi.get({
          url: REACT_APP_URL_COUNTRY_LIST_ALL
        });

        const list = Array.isArray(response?.result) ? response.result : [];
        return list;
      } catch (error) {
        throw error;
      } finally {
        countryListPromise = null;
      }
    })();

    try {
      const result = await countryListPromise;
      if (isMountedRef.current) {
        dispatch(getListCountryAll(result));
        setData(result);
        setLoading(false);
      }
      return result;
    } catch (err) {
      if (isMountedRef.current) {
        setError(err);
        setData([]);
        setLoading(false);
      }
      return [];
    }
  }, [dispatch]);

  useEffect(() => {
    isMountedRef.current = true;

    // Always fetch when component mounts
    // This ensures Dashboard always has fresh data
    fetchCountryList();

    return () => {
      isMountedRef.current = false;
    };
  }, []); // Empty dependency array to run only once on mount

  return { data, loading, error, refetch: fetchCountryList };
};

export default useFetchCountryList;
